import { render, staticRenderFns } from "./AmalgamationShareholdingForm10.vue?vue&type=template&id=62f866f8&scoped=true&"
import script from "./AmalgamationShareholdingForm10.vue?vue&type=script&lang=js&"
export * from "./AmalgamationShareholdingForm10.vue?vue&type=script&lang=js&"
import style0 from "./AmalgamationShareholdingForm10.vue?vue&type=style&index=0&id=62f866f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f866f8",
  null
  
)

export default component.exports